import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { Avatar, Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { InfoIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons } from '@fluentui/react';
import { getAppConfig, getMeetingData, getAppSettings } from '../../../../api/publicapp-api';
import "./access-disabled.scss";
import { CommonHelper } from '../../../../helpers/common-helper';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";

interface IState {
    appConfigs: any;
    appSettings: any;
    ancora: string;
    meetingData: any;
    loader: any;
}

export type AccessDisabledProps = {} & RouteComponentProps & WithTranslation;

class AccessDisabled extends React.Component<AccessDisabledProps, IState> {
    private localize: TFunction;

    constructor(props: AccessDisabledProps) {
        super(props);
        initializeIcons();
        this.localize = this.props.t;

        let pathname = window.location.pathname;

        this.state = {
            appConfigs: null,
            appSettings: null,
            ancora: pathname.split("/")[2],
            meetingData: [],
            loader: true,
        }
    }

    /**
    * Used to initialize this component.
    */
    public async componentDidMount() {
        setTimeout(() => this.setState({ loader: false }), 2500);

        this.getAppConfig();
        this.getAppSettings();
        this.getMeetingData();
    }

    /**
     * Get App Configs
     * */
    private async getAppConfig() {

        let response = await getAppConfig();
        if (response.status === 200 && response.data) {
            this.setState({
                appConfigs: response.data,
            });
        }
    };

    /**
     * Get App Settings
     * */
    private async getAppSettings() {
        let response = await getAppSettings();
        if (response.status === 200 && response.data) {
            this.setState({
                appSettings: response.data,
            });
        }
    };

    /**
    * Get meeting data.
    */
    public async getMeetingData() {
        let response = await getMeetingData(this.state.ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingData: response.data,
            });
        }
    }

    /**
     * Parse week days with locale
     * */
    public daysOfWeekLocale = (day: string) => {
        if (day)
            return day
                .replace(/segunda-feira/, this.localize('SegundaFeira'))
                .replace(/terça-feira/, this.localize('TercaFeira'))
                .replace(/quarta-feira/, this.localize('QuartaFeira'))
                .replace(/quinta-feira/, this.localize('QuintaFeira'))
                .replace(/sexta-feira/, this.localize('SextaFeira'))
                .replace(/sabado/, this.localize('Sabado'))
                .replace(/domingo/, this.localize('Domingo'))
    }

    /**
    * Render header.
    */
    public renderHeader() {
        return (
            this.state.appConfigs ?
                <Flex>
                    <Flex.Item>
                        <Flex gap="gap.small" vAlign="center">
                            <Image src="/images/logo.png" />
                            <Text weight="semibold" content={this.localize("BalcaoVirtual").toUpperCase()} size="medium" />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item grow>
                        <Flex hAlign="center" vAlign="center">
                            <Label className="headerLabel" content={this.state.appConfigs.tribunal} />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item>
                        <Flex gap="gap.smaller" vAlign="center" className="sobre">
                            <InfoIcon outline />
                            <Text weight="light" content={this.localize("Sobre")} size="small" />
                        </Flex>
                    </Flex.Item>
                </Flex>
                :
                <React.Fragment />
        )
    }

    /**
    * Render body.
    */
    public renderBody() {
        return (
            <React.Fragment>
                <Flex gap="gap.large" className="card">
                    <Avatar icon={<Image src="/images/logo.png" />} />
                    <Image hidden={!this.state.loader} className="typing" src="/images/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={this.state.loader}
                            className="dialog2"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Flex>
                                        <Flex column>
                                            <Flex gap="gap.large">
                                                <Label
                                                    className="disabled-label"
                                                    content={(
                                                        <Flex column>
                                                            <Text align="center" styles={{ marginTop: "24px" }} size="medium" content={`Acesso indisponível`} />
                                                        </Flex>
                                                    )}
                                                />
                                            </Flex>

                                            <Flex gap="gap.small" styles={{ marginTop: "15px !important" }}>

                                                {this.state.appSettings && this.state.appSettings.ajudaComoFunciona &&
                                                    <Button content={this.localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(this.state.appSettings.ajudaComoFunciona), "_blank")} />
                                                }

                                                {this.state.appSettings && this.state.appSettings.ajudaPerguntasFrequentes &&
                                                    <Button content={this.localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(this.state.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                                }

                                            </Flex>

                                        </Flex>
                                        <Flex.Item align="end" className="fora-horario">
                                            <Image src="/images/cancel.svg" className="canceled" />
                                        </Flex.Item>
                                    </Flex>



                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>

            </React.Fragment>
        )
    }

    /**
     * Render this component.
     * */
    public render(): JSX.Element {
        return (
            <React.Fragment>
                <div className="aviso-fora">
                    <div className="header">
                        <Segment
                            className="headerLine"
                            inverted
                            content={this.renderHeader()}
                        />
                    </div>
                    <div className="body">
                        {this.renderBody()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const accessDisabledWithTranslation = withTranslation()(AccessDisabled);
export default accessDisabledWithTranslation;